import React from 'react';
import SEO from '../components/SEO';

/**
 * Open Source Licences — placeholder route so mobile Settings → Legal
 * can link to it without a 404. Real license inventory to be published
 * via build tooling before Google Play submission.
 */
const OpenSourceLicensesPage = () => (
  <div className="min-h-screen bg-gray-50 py-12 px-4" data-testid="open-source-page">
    <SEO
      title="Open Source Licences"
      description="TreatX Open Source Licences — inventory of open-source components used across the platform."
      canonicalPath="/open-source"
    />
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-6 sm:p-8 lg:p-10">
      <h1 className="text-2xl font-semibold text-slate-900">Open Source Licences</h1>
      <p className="mt-4 text-sm text-slate-600">
        TreatX uses open-source software components. The full inventory of
        component names, versions, and their respective licences is being
        prepared and will be published here prior to the first application
        store release.
      </p>
      <p className="mt-4 text-sm text-slate-600">
        For questions or specific licence enquiries, please use the{' '}
        <a className="text-primary underline" href="/#/contact" data-testid="oss-contact-link">
          Contact page
        </a>
        .
      </p>
    </div>
  </div>
);

export default OpenSourceLicensesPage;
